import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getSelectedRangeOption
} from "../../../../../utils/date-range-options";

import {
  SET_LOADING,
  SET_DETAILS_MODAL_LOADING,
  SET_TABLE_DATA_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_CHART_SUCCESS,
  FETCH_TABLE_DATA_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  UPDATE_CLASS_FILTERS,
  UPDATE_STAFF_FILTERS,
  UPDATE_CHART_SUCCESS,
  SET_FILTERS_DIRTY,
  SET_DATES,
  UPDATE_DATES,
  UPDATE_CUSTOM_RANGE,
  UPDATE_CATEGORY_FILTER,
  SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS,
  RESET_CATEGORY_FILTER,
  RESET_FILTERS,
  SET_CLASS_FILTERS_LOADING,
  SET_STAFF_FILTERS_LOADING,
  SET_BOOKING_STATUS_FILTERS_LOADING,
  UPDATE_FILTERS_BY_STAFF_SUCCESS,
  UPDATE_FILTERS_BY_CLASS_SUCCESS,
  SET_PRIMARY_FILTER,
  FETCH_GRAPH_SUCCESS,
  UPDATE_PERIOD_TYPE_SELECTED,
  YEAR_OVER_YEAR_LOADING,
  SET_UPDATES_LOADING,
  UPDATE_BOOKING_STATUS_FILTER_SELECTED,
  RESET_BOOKING_STATUS_FILTER_SELECTED,
  SET_AVERAGE,
  UPDATE_FUTURE_BOOKINGS,
  SET_DATES_FOR_FUTURE_BOOKING,
  UPDATE_GROUP_BY_FILTER,
  FETCH_MODAL_DATA_SUCCESS,
  RESET_DETAILS_MODAL_DATA
} from "./../sagas/utilization";

import startCase from "lodash/startCase";
import numbro from "numbro";

const formatCategories = (data) =>
  data.map((item, i) => ({
    id: i + 1,
    name: item[1]
  }));

const formatBookingStatuses = (data) =>
  data.map((item, i) => ({
    id: i + 1,
    requestId: item[0],
    name: item[1]
  }));

function formatCat(data) {
  let newData;
  if (data.name === "Average Class Size") {
    newData = {
      id: data.id,
      name: "average_class_size"
    };
  }
  if (startCase(data.name) === startCase("Number of Clients")) {
    newData = {
      id: data.id,
      name: "total_number_of_clients"
    };
  }
  if (data.name === "Utilization") {
    newData = {
      id: data.id,
      name: "utilization"
    };
  }
  if (data.name === "Average Revenue") {
    newData = {
      id: data.id,
      name: "average_revenue"
    };
  }
  return newData;
}

function filterValues(data) {
  const newData = [];
  data.map((item) => {
    if (item.selected) {
      newData.push(item);
    }
  });
  return newData;
}

function removeCheckedClass(data = []) {
  const newClassData = [];
  data.class_values.map((item) => {
    if (item.selected) {
      newClassData.push(item);
    }
  });
  const newData = { staff_values: data.staff_values, class_values: newClassData };
  return newData;
}

function removeCheckedStaff(data) {
  const newClassData = [];
  data.staff_values.map((item) => {
    if (item.selected) {
      newClassData.push(item);
    }
  });
  const newData = { staff_values: newClassData, class_values: data.class_values };
  return newData;
}

function getSelectedCategoryName(category) {
  let categoryName;
  if (category === "utilization") {
    categoryName = "Utilization";
  }
  if (category === "total_number_of_clients") {
    categoryName = "Number of Clients";
  }
  if (category === "average_class_size") {
    categoryName = "Average Class Size";
  }
  if (category === "average_revenue") {
    categoryName = "Average Revenue";
  }
  return categoryName;
}

function getChartCurrencySymbol(selectedCategoryFilters, action, fallbackCurrency) {
  switch (selectedCategoryFilters.name) {
    case "average_revenue":
      return action.payload.currency || fallbackCurrency;
    case "utilization":
      return "%";
    default:
      return "";
  }
}

function getChartValues(chartValues, average) {
  if (average && average !== "Not selected") {
    return chartValues.map((val) => ({
      ...val,
      additionalTooltip:
        average +
        " Average : " +
        numbro(Math.round(val.avgValue)).format({ thousandSeparated: true })
    }));
  }

  return chartValues;
}

function getDataPointsWithTotal(
  categoryName,
  payload,
  average,
  averageTooltip,
  chartCurrencySymbol
) {
  const { current_value, growth_value, avg_value, url, utilization_by_category } = payload;
  const otherDataPoints = utilization_by_category;

  const subProps = ({ avg_value, growth, fontSize }) => {
    return {
      subProps:
        average && average !== "Not selected"
          ? {
              averageProps: {
                average: avg_value,
                toolTip: averageTooltip,
                fontSize,
                symbol: chartCurrencySymbol,
                format: { mantissa: 0 }
              }
            }
          : {
              changeProps: {
                changeValue: growth,
                showBorder: true,
                toolTip: "Percentage change from previous period"
              }
            }
    };
  };

  const total = {
    label: "Total " + categoryName,
    value: Math.round(current_value),
    url: url,
    ...subProps({
      avg_value,
      growth: growth_value / 100
    })
  };

  let formatted = otherDataPoints.map((dataPoint) => {
    return {
      ...dataPoint,
      value: Math.round(dataPoint.value),

      ...subProps({ avg_value: dataPoint.avg_value, growth: dataPoint.growth, fontSize: 14 })
    };
  });

  return { utilization_by_category: [total, ...formatted] };
}

export const initialState = {
  currentUser: {},
  numberOfMonths: null,
  graphData: {},
  series: [],
  isLoading: true,
  isDetailsModalLoading: true,
  bookingStatusFilterLoading: false,
  updatesLoading: false,
  modalTableData: {},
  filters: {},
  tableDataLoading: true,
  selectedClassFilters: {},
  selectedStaffFilters: {},
  filtersDirty: false,
  selectedRequestDates: {},
  staffFiltersLoading: false,
  classFiltersLoading: false,
  primaryFilter: "",
  categories: [],
  periodType: "Weekly",
  yearOverYearLoading: true,
  chartCurrencySymbol: "%",
  currentSelectedCategory: "Utilization",
  selectedPeriodType: {
    id: 2,
    name: "Weekly"
  },
  periodTypeOptions: [
    {
      id: 1,
      name: "Daily"
    },
    {
      id: 2,
      name: "Weekly"
    },
    {
      id: 3,
      name: "Monthly"
    },
    {
      id: 4,
      name: "Yearly"
    }
  ],
  selectedCategoryFilters: {
    id: 1,
    name: "utilization"
  },
  selectedCategoryFiltersDisplay: {
    id: 1,
    name: "Utilization"
  },
  future_bookings: false,
  average: null,
  subAverageFilterOptions: {},
  selectedSubAverageFilterOptions: [],
  averageTooltip: null,
  selectedRangeOption: {},
  rangeOptions: [],
  bookingStatusOptions: [],
  selectedBookingStatusOption: {
    requestId: "5",
    id: 1,
    name: "Completed"
  },
  groupByWeekDay: false,
  showUtilizationPrevPeriod: true,
  averageIsNotSelected: true,
  showAverages: false,
  groupByFilterOption: [
    { id: "not_grouped", name: "Not Grouped" },
    { id: "day_of_the_week", name: "Group by Day of the Week" },
    { id: "time_of_day", name: "Group by Time of Day" }
  ],
  selectedGroupByFilterOption: { id: "not_grouped", name: "Not Grouped" },
  groupByTimeOfDay: false,
  minDate: null,
  maxDate: null,
  detailsModalData: {}
};

function adjustForNestedRows(tableInfo) {
  const { colHeaders = [], data = [] } = tableInfo;
  let ind = tableInfo.colHeaders.findIndex((el) => el == "Utilization");

  if (ind >= 0) {
    let firstLevelHeaders = colHeaders.slice(0, ind + 1);
    let nestedHeaders = colHeaders.slice(ind + 1);
    let offset = nestedHeaders.length == 5 ? 0 : 1;

    let formattedData = [];
    data.forEach((rowArr, index) => {
      formattedData[index] = {
        ...firstLevelHeaders.reduce((acc, header, index) => {
          let key = header.toLowerCase();
          let val = rowArr[index];
          let nestedHeader = colHeaders[index + ind + offset];
          let nestedRowVal = rowArr[index + ind + offset];
          let children = [];
          let omitFirstCell = key == "instructor" && offset == 0;

          children[0] = {
            ...acc?.__children?.[0],
            [key]: omitFirstCell ? null : nestedHeader
          };

          children[1] = {
            ...acc?.__children?.[1],
            [key]: omitFirstCell ? null : nestedRowVal
          };

          acc = {
            ...acc,
            [key]: val,
            __children: children
          };
          return acc;
        }, {})
      };
    });
    return {
      data: formattedData,
      colHeaders: firstLevelHeaders
    };
  }

  return tableInfo;
}

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_DETAILS_MODAL_LOADING]: (state, action) => ({
      ...state,
      isDetailsModalLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [YEAR_OVER_YEAR_LOADING]: (state, action) => ({
      ...state,
      yearOverYearLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptions(action.payload.endDate, state.currentUser.calendarStartDate),
      selectedRangeOption: getSelectedRangeOption(action)
    }),
    [SET_AVERAGE]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      average: payload,
      averageTooltip: payload !== "Not selected" ? payload + " Averages" : "",
      selectedSubAverageFilterOptions: state.subAverageFilterOptions[payload] || [],
      averageIsNotSelected: payload === "Not selected"
    }),
    [SET_SUB_AVERAGE_FILTER_SELECTED_OPTIONS]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedSubAverageFilterOptions: payload
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [UPDATE_GROUP_BY_FILTER]: (state, action) => ({
      ...state,
      selectedGroupByFilterOption: action.payload,
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [SET_TABLE_DATA_LOADING]: (state, action) => ({
      ...state,
      tableDataLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload.currentUser || state.currentUser,
      numberOfMonths: action.payload.numberOfMonths || state.numberOfMonths,
      groupByWeekDay: false,
      groupByTimeOfDay: false,
      selectedGroupByFilterOption: initialState.selectedGroupByFilterOption,
      showUtilizationPrevPeriod: true
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      series: action.payload || state.series,
      currentSelectedCategory: getSelectedCategoryName(state.selectedCategoryFilters.name)
    }),
    [FETCH_GRAPH_SUCCESS]: (state, action) => {
      let chartCurrencySymbol = getChartCurrencySymbol(
        state.selectedCategoryFilters,
        action,
        state.chartCurrencySymbol
      );
      return {
        ...state,
        graphData:
          {
            ...action.payload,
            chart_values: getChartValues(action.payload.chart_values, state.average),
            ...getDataPointsWithTotal(
              state.selectedCategoryFiltersDisplay.name,
              action.payload,
              state.average,
              state.averageTooltip,
              chartCurrencySymbol
            )
          } || state.graphData,
        chartCurrencySymbol,
        yearOverYearLoading: false
      };
    },
    [UPDATE_CHART_SUCCESS]: (state, action) => ({
      ...state,
      series: action.payload || state.series,
      chartCurrencySymbol: getChartCurrencySymbol(
        state.selectedCategoryFilters,
        action,
        state.chartCurrencySymbol
      ),
      currentSelectedCategory: getSelectedCategoryName(state.selectedCategoryFilters.name),
      showUtilizationPrevPeriod:
        state.selectedGroupByFilterOption.id !== "day_of_the_week" && !state.future_bookings,
      showAverages:
        !state.averageIsNotSelected &&
        !state.filters.class_values.length &&
        !state.filters.staff_values.length,
      groupByTimeOfDay: state.selectedGroupByFilterOption.id === "time_of_day",
      groupByWeekDay: state.selectedGroupByFilterOption.id === "day_of_the_week"
    }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, action) => ({
      ...state,
      modalTableData: adjustForNestedRows(action.payload.tableInfo || state.modalTableData),
      tableDataLoading: false
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload || state.filters,
      categories: formatCategories(action.payload.category_types),
      selectedClassFilters: action.payload.class_values || state.selectedClassFilters,
      selectedStaffFilters: action.payload.staff_values || state.selectedStaffFilters,
      bookingStatusOptions: formatBookingStatuses(action.payload.get_visit_statuses),
      subAverageFilterOptions: {
        Division: action.payload?.divisions || [],
        District: action.payload?.districts || [],
        Region: action.payload?.regions || []
      }
    }),
    [UPDATE_FILTERS_BY_STAFF_SUCCESS]: (state, action) => ({
      ...state,
      filters: removeCheckedClass(action.payload),
      selectedClassFilters: filterValues(action.payload.class_values),
      classFiltersLoading: false
    }),
    [UPDATE_FILTERS_BY_CLASS_SUCCESS]: (state, action) => ({
      ...state,
      filters: removeCheckedStaff(action.payload),
      selectedStaffFilters: filterValues(action.payload.staff_values),
      staffFiltersLoading: false
    }),
    [UPDATE_CLASS_FILTERS]: (state, action) => ({
      ...state,
      selectedClassFilters: action.payload || state.selectedClassFilters,
      filtersDirty: true
    }),
    [UPDATE_CATEGORY_FILTER]: (state, action) => ({
      ...state,
      selectedCategoryFilters: formatCat(action.payload),
      selectedCategoryFiltersDisplay: action.payload,
      filtersDirty: true
    }),
    [RESET_CATEGORY_FILTER]: (state, action) => ({
      ...state,
      selectedCategoryFilters: formatCat(action.payload),
      selectedCategoryFiltersDisplay: action.payload
    }),
    [UPDATE_STAFF_FILTERS]: (state, action) => ({
      ...state,
      selectedStaffFilters: action.payload || state.selectedStaffFilters,
      filtersDirty: true
    }),

    [UPDATE_BOOKING_STATUS_FILTER_SELECTED]: (state, action) => ({
      ...state,
      selectedBookingStatusOption: action.payload || state.selectedTypeOption,
      filtersDirty: true
    }),
    [RESET_BOOKING_STATUS_FILTER_SELECTED]: (state) => {
      const bookingStatusByDefault = state.future_bookings ? "Open Booking" : "Completed";
      const selectedBookingStatus = state.bookingStatusOptions.filter(
        (option) => option.name === bookingStatusByDefault
      );
      return {
        ...state,
        selectedBookingStatusOption: selectedBookingStatus[0]
      };
    },
    [UPDATE_PERIOD_TYPE_SELECTED]: (state, action) => ({
      ...state,
      periodType: action.payload.name,
      selectedPeriodType: action.payload
    }),
    [SET_CLASS_FILTERS_LOADING]: (state, action) => ({
      ...state,
      classFiltersLoading: action.payload
    }),
    [SET_STAFF_FILTERS_LOADING]: (state, action) => ({
      ...state,
      staffFiltersLoading: action.payload
    }),
    [SET_BOOKING_STATUS_FILTERS_LOADING]: (state, action) => ({
      ...state,
      bookingStatusFilterLoading: action.payload
    }),
    [SET_PRIMARY_FILTER]: (state, action) => ({
      ...state,
      primaryFilter: action.payload
    }),
    [UPDATE_FUTURE_BOOKINGS]: (state, action) => ({
      ...state,
      filtersDirty: true,
      future_bookings: action.payload
    }),
    [SET_DATES_FOR_FUTURE_BOOKING]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload.selectedRequestDates,
      minDate: action.payload.minDate,
      maxDate: action.payload.maxDate,
      filtersDirty: true
    }),
    [RESET_FILTERS]: (state) => ({
      ...state,
      selectedCategoryFilters: initialState.selectedCategoryFilters,
      selectedCategoryFiltersDisplay: initialState.selectedCategoryFiltersDisplay,
      primaryFilter: initialState.primaryFilter,
      selectedBookingStatusOption: initialState.selectedBookingStatusOption,
      future_bookings: initialState.future_bookings,
      detailsModalData: initialState.detailsModalData
    }),
    [FETCH_MODAL_DATA_SUCCESS]: (state, action) => ({
      ...state,
      detailsModalData: { ...state.detailsModalData, ...action.payload }
    }),
    [RESET_DETAILS_MODAL_DATA]: (state) => ({
      ...state,
      detailsModalData: initialState.detailsModalData
    })
  },
  initialState
);
